import React, { Component } from "react";

import PAInputPrices from "./PAInputPrices";

import { Tooltip, Button, Collapse, Input, FormGroup, ButtonAction } from "xsolla-uikit";
import { throws } from "assert";

export default class PACollapsePrices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curs: this.props.curs || null,
      platforms: this.props.platforms || null
    };


    this.label = this.props.label || "";
    this.localesList = this.props.localeList || [
      "English",
      "Russian",
      "French"
    ];
    this.content = this.props.content || [];
  }


  handeCurrDel = (k, e) => {
    // if (!k) return;
    var newCurrs = [...this.state.curs]; // make a separate copy of the array
    if (k !== -1) {
      newCurrs.splice(k, 1);
      this.setState({ curs: newCurrs });
    }
    this.props.handleParentCurs(newCurrs)
  };

  handeCurrAdd = e => {
    let newCurr = {
      curr: this.state.curs[0].curr,
      platform: this.state.curs[0].platform,
      price: this.state.curs[0].price,
      currLocked: false,
      add: false
    };
    this.setState({
      curs: [...this.state.curs, newCurr]
    },
      () => {
        this.props.handleParentCurs(this.state.curs)
      }
    )

  }

  handleCurrValue = (curIndex, what, newValue) => {
    // debugger;
    let newCurs = [...this.state.curs];
    newCurs[curIndex][what] = newValue;
    this.setState({
          curs: [...newCurs]
      }, () => {
      this.props.handleParentCurs(this.state.curs)
    })
  }

  componentDidUpdate = () => {

  }

  render() {
    return (
      <div>
          <Collapse
            isOpened={true}
            staticElements={1}
            collapsedLabel={count => `${count} more pricing options`}
            expandedLabel={() => "Hide pricing options"}
          >
            {this.state.curs &&
              this.state.curs.map((oneCur, k) => {
                return (
                  <FormGroup
                    key={k}
                    // label={`${this.props.label} | ${locale}`}
                    indentation="sm"
                    // tooltip={'Project name'}
                  >

                    <FormGroup indentation="sm">
                      <PAInputPrices
                        key={k}
                        id={k}
                        sku={this.props.sku}
                        curr={oneCur.curr}
                        platform={oneCur.platform}
                        price={oneCur.price}
                        currLocked={oneCur.currLocked}
                        add={oneCur.add}
                        handeCurrDel={this.handeCurrDel.bind(this)}
                        currs={this.state.curs}
                        platforms={this.state.platforms}
                        handleAddPlatformFromPrices={this.props.handleAddPlatformFromPrices}
                        handleCurrValue={this.handleCurrValue.bind(this)}
                      />
                    </FormGroup>

                    {k + 1 === this.state.curs.length && (
                      <FormGroup indentation="sm">
                        <ButtonAction icon="add" onClick={this.handeCurrAdd}>
                          Add pricing option
                        </ButtonAction>
                      </FormGroup>
                    )}

                    {/* {(k - 1) === this.state.curs.length && <ButtonAction
                          icon="add"
                          onClick={this.handeCurrAdd}>
                          Add pricing option
                        </ButtonAction>} */}
                  </FormGroup>
                );
              })}
          </Collapse>

        {/* <Collapse
                btnIconPosition="end"
                staticElements={1}
                showElementsInline={true}
                collapsedLabel={() => 'Show more'}
                expandedLabel={() => 'Collapse'}>
                {[
                  <span key={0}>{this.bigText.substr(0, 200)}</span>,
                  <span key={1}>{this.bigText.substr(200)}</span>
                ]}
              </Collapse> */}
      </div>
    );
  }
}
